import React from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import {
  APP_BASE_ROUTE,
  ROUTE_LANDING,
  ROUTE_SEARCH_STOPS,
  ROUTE_STOP_INFO_SQUARE,
} from "../../utils/routes";
import { COMMON__ERROR_404 } from "../../translations/constans";
import ErrorComponent from "../common/ErrorComponent";
import SearchStopsComponent from "../../pages/searchStops/SearchStopsComponent";
import StopInfoComponentSquare from "../../pages/stopInfoSquare/StopInfoComponentSquare";

const Routers = () => {
  return (
    <BrowserRouter basename={APP_BASE_ROUTE}>
      <Routes>
        <Route
          exact
          path={ROUTE_LANDING}
          element={<Navigate to={ROUTE_STOP_INFO_SQUARE} replace/>}
        />
        <Route
          exact
          path={ROUTE_LANDING}
          element={<ErrorComponent error={COMMON__ERROR_404} />}
        />
        <Route
          exact
          path={ROUTE_SEARCH_STOPS}
          element={<SearchStopsComponent />}
        />
        <Route
          exact
          path={ROUTE_STOP_INFO_SQUARE}
          element={<StopInfoComponentSquare />}
        />
      </Routes>
    </BrowserRouter>
  );
};

export default Routers;
